export const Power01 = ({ ...props }: React.SVGProps<SVGSVGElement>) => (
   <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
   >
      <g clipPath="url(#clip0_621_343)">
         <path
            d="M11.2499 2.88663C11.2522 3.03578 11.2981 3.18099 11.382 3.30438C11.4658 3.42777 11.5838 3.52397 11.7216 3.58113C12.9533 4.12307 13.9949 5.02076 14.7126 6.15896C15.4304 7.29716 15.7916 8.62391 15.7499 9.96888C15.7208 11.7591 14.9818 13.4644 13.6954 14.7098C12.409 15.9551 10.6806 16.6384 8.89036 16.6094C7.10015 16.5803 5.3948 15.8413 4.14946 14.5549C2.90413 13.2685 2.22082 11.5401 2.24986 9.74988C2.2516 8.44205 2.63322 7.16289 3.34835 6.06789C4.06348 4.97289 5.08131 4.10923 6.27811 3.58188C6.41596 3.52438 6.53402 3.42789 6.61782 3.30426C6.70162 3.18062 6.74751 3.03522 6.74986 2.88588C6.75006 2.76304 6.72007 2.64203 6.66255 2.53349C6.60502 2.42495 6.52172 2.3322 6.41995 2.26339C6.31819 2.19459 6.20108 2.15183 6.07892 2.13888C5.95676 2.12593 5.83329 2.14319 5.71936 2.18913C3.97883 2.94374 2.55153 4.27514 1.67789 5.95908C0.804242 7.64301 0.537635 9.57659 0.92297 11.4341C1.30831 13.2917 2.32204 14.9596 3.79342 16.1571C5.2648 17.3546 7.10391 18.0084 9.00099 18.0084C10.8981 18.0084 12.7372 17.3546 14.2086 16.1571C15.6799 14.9596 16.6937 13.2917 17.079 11.4341C17.4643 9.57659 17.1977 7.64301 16.3241 5.95908C15.4504 4.27514 14.0232 2.94374 12.2826 2.18913C12.1685 2.14269 12.0447 2.12507 11.9222 2.13782C11.7997 2.15058 11.6822 2.19331 11.5801 2.26226C11.478 2.33121 11.3945 2.42424 11.3369 2.53314C11.2793 2.64204 11.2494 2.76344 11.2499 2.88663Z"
            fill="currentColor"
         />
         <path
            d="M9.75 1.02319C9.75 0.458099 9.41421 0 9 0C8.58579 0 8.25 0.458099 8.25 1.02319V7.16235C8.25 7.72745 8.58579 8.18555 9 8.18555C9.41421 8.18555 9.75 7.72745 9.75 7.16235V1.02319Z"
            fill="currentColor"
         />
      </g>
      <defs>
         <clipPath id="clip0_621_343">
            <rect width="18" height="18" fill="currentColor" />
         </clipPath>
      </defs>
   </svg>
)
